import ParseError from "./ParseError.mjs";
/**
 * @public
 */
class ParserError extends ParseError {}
export default ParserError;